import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { UserResponse } from '../../user.model';

@Component({
  selector: 'app-user-info',
  imports: [MatCardModule],
  templateUrl: './user-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class UserInfoComponent {
  readonly title = input('User info');
  readonly subtitle = input('');
  readonly user = input<UserResponse | null>(null);
}
